var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import NotificationSettings from '@/components/NotificationSettings';
import UserNotification from '@/components/UserNotification';
import { AssignmentsStore, FeedbackStore, NotificationStore } from '@/store';
let InnerUserNotifications = class InnerUserNotifications extends Vue {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    showSettings;
    // eslint-disable-next-line
    get allNotifications() {
        return NotificationStore.getAllNotifications();
    }
    // eslint-disable-next-line
    get unreadNotifications() {
        return NotificationStore.getAllUnreadNotifications();
    }
    // eslint-disable-next-line
    get hasUnreadNotifications() {
        return NotificationStore.getHasUnreadNotifications();
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get hasReadNotifications() {
        return this.allNotifications.length > this.unreadNotifications.length;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get notifications() {
        return this.showRead ? this.allNotifications : this.unreadNotifications;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get disabled() {
        return this.goingToSubmission != null;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    loading;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    disableAnimations;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    goingToSubmission;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    showRead;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    isDestroyed;
    /** Create this class. */
    constructor() {
        super();
        this.loading = true;
        this.disableAnimations = false;
        this.goingToSubmission = null;
        this.showRead = false;
        this.isDestroyed = false;
    }
    /** Vue's component destruction hook. */
    destroyed() {
        this.$getRootInstance().$loadFullNotifications = false;
        this.isDestroyed = true;
    }
    /** Vue's component creation hook. */
    async created() {
        this.loading = true;
        this.$getRootInstance().$loadFullNotifications = true;
        await NotificationStore.dispatchLoadNotifications();
        this.loading = false;
    }
    /* eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation. */
    getNotificationRoute(notification) {
        return notification.assignment.mapOrDefault(assig => {
            const baseRoute = {
                params: {
                    courseId: assig.courseId.toString(10),
                    assignmentId: assig.id.toString(10),
                    submissionId: notification.submissionId.toString(10),
                },
                query: {
                    replyToFocus: notification.focusId,
                },
            };
            return notification.fileId.caseOf({
                Nothing: () => ({ ...baseRoute, name: 'submission', hash: '#feedback-overview' }),
                Just: fileId => ({
                    ...baseRoute,
                    name: 'submission_file',
                    params: { ...baseRoute.params, fileId },
                    hash: '#code',
                }),
            });
        }, null);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    async gotoNotification(notification) {
        const assignmentId = notification.assignmentId;
        const submissionId = notification.submissionId;
        this.goingToSubmission = notification.id;
        notification.markAsRead().then(({ cgResult }) => {
            NotificationStore.commitUpdateNotifications({
                notifications: [cgResult],
            });
        });
        await Promise.all([
            AssignmentsStore.loadSingleAssignment({
                assignmentId: notification.assignmentId,
            }),
            FeedbackStore.loadFeedback({
                assignmentId,
                submissionId,
                force: true,
            }),
        ]);
        const location = this.getNotificationRoute(notification);
        if (location != null) {
            this.$router.push(location);
            this.$root.$emit('cg::sidebar::close');
        }
    }
};
__decorate([
    Prop({ required: true })
], InnerUserNotifications.prototype, "showSettings", void 0);
InnerUserNotifications = __decorate([
    Component({
        components: {
            UserNotification,
            NotificationSettings,
        },
    })
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
], InnerUserNotifications);
export default InnerUserNotifications;
